import { createFileRoute } from '@tanstack/react-router';
import { MarketingBulkSmsPage } from '@/features/marketing';

/**
 * Bulk SMS — `/marketing/bulk-sms/{id}` (focused screen: Compose → Review → Result, not tabbed). A Clients-page
 * batch is handed over to the focus view on Clients (`/clients?text={id}`).
 */
export const Route = createFileRoute('/_auth/$orgId/marketing/bulk-sms_/$bulkSendId')({
  component: BulkSmsRoute,
});

function BulkSmsRoute() {
  const { orgId, bulkSendId } = Route.useParams();
  return <MarketingBulkSmsPage orgId={orgId} bulkSendId={bulkSendId} />;
}
